import Fetcher from "../service/fetcher/fetcher";

class MarkAPI {
  public static setMark = (id: string, mark: number, type: string) =>
    Fetcher.post("/mark", { id_thing: id, mark, type });
}

export default MarkAPI;
